import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const employeeWeeklyReportManagement = createApi({
    reducerPath: "employeeWeeklyReportManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        employeeWeeklyReportList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/employee/weekly-report`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewEmployeeWeeklyReport: builder.mutation({
            query: (employeeWeeklyReport) => ({
                url: `v1/${locale}/employee/weekly-report/${employeeWeeklyReport}`,
                method: "GET",
            }),
        }),
        addEmployeeWeeklyReport: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/employee/weekly-report`,
                method: "POST",
                body: body,
            }),
        }),
        updateEmployeeWeeklyReport: builder.mutation({
            query: ({ body, employeeWeeklyReport }) => ({
                url: `v1/${locale}/employee/weekly-report/${employeeWeeklyReport}`,
                method: "PATCH",
                body: body,
            }),
        }),
        sendEmployeeWeeklyReport: builder.mutation({
            query: ({employeeWeeklyReport}) => ({
                url: `v1/${locale}/employee/weekly-report/${employeeWeeklyReport}/send-one`,
                method: "PATCH",
            }),
        }),
        verifyEmployeeWeeklyReport: builder.mutation({
            query: ({employeeWeeklyReport}) => ({
                url: `v1/${locale}/employee/weekly-report/${employeeWeeklyReport}/verify-one`,
                method: "PATCH",
            }),
        }),
        addEmployeeWeeklyReportNote: builder.mutation({
            query: ({body, weeklyReportId}) => ({
                url: `v1/${locale}/employee/weekly-report/${weeklyReportId}/notes`,
                method: "POST",
                body: body,
            }),
        }),
        employeeWeeklyReportNoteList: builder.mutation({
            query: ({weeklyReportId}) => ({
                url: `v1/${locale}/employee/weekly-report/${weeklyReportId}/notes`,
                method: "GET",
            }),
        }),
        updateEmployeeWeeklyReportNote: builder.mutation({
            query: ({ body, weeklyReportNoteId }) => ({
                url: `v1/${locale}/employee/weekly-report/notes/${weeklyReportNoteId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        viewEmployeeWeeklyReportNote: builder.mutation({
            query: ({weeklyReportNoteId}) => ({
                url: `v1/${locale}/employee/weekly-report/notes/${weeklyReportNoteId}`,
                method: "GET",
            }),
        }),
    }),
});

export const {
    useAddEmployeeWeeklyReportMutation,
    useEmployeeWeeklyReportListMutation,
    useSendEmployeeWeeklyReportMutation,
    useVerifyEmployeeWeeklyReportMutation,
    useUpdateEmployeeWeeklyReportMutation,
    useViewEmployeeWeeklyReportMutation,

    useAddEmployeeWeeklyReportNoteMutation,
    useEmployeeWeeklyReportNoteListMutation,
    useUpdateEmployeeWeeklyReportNoteMutation,
    useViewEmployeeWeeklyReportNoteMutation
} = employeeWeeklyReportManagement;
